
export const headerPlanet = "詳細"

export const headerTextPlanet = "のプラネット"